var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPricing5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#F87315"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 10.4167C11.1519 10.4167 12.0846 9.48393 12.0846 8.33333C12.0846 7.18274 11.1519 6.25 10.0013 6.25C8.85071 6.25 7.91797 7.18274 7.91797 8.33333C7.91797 9.48393 8.85071 10.4167 10.0013 10.4167Z",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 13.7498C13.3346 12.8658 12.9834 12.0179 12.3583 11.3928C11.7332 10.7677 10.8854 10.4165 10.0013 10.4165C9.11725 10.4165 8.2694 10.7677 7.64428 11.3928C7.01916 12.0179 6.66797 12.8658 6.66797 13.7498",
    stroke: "white",
    strokeWidth: 0.833333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricing5);
export default __webpack_public_path__ + "static/media/pricing 5.7c15f64f58089325f8f27665ec2d4bce.svg";
export { ForwardRef as ReactComponent };